export default __webpack_public_path__ + "static/media/Hira.de3d3eda.jpg";